<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div class="loader-background" fxLayout="row" fxLayoutAlign="center center">
  <img class="loader" src="assets/icons/loader.gif" alt="processing" />
</div>
